import { Languages } from "src/common/descriptions/types";
import { PayableContractsDescriptions } from "./types";

const DescriptionsEnUs: PayableContractsDescriptions = {
    TITLE: "Payable Contracts",
    TABLE: {
        ACTION_BUTTON: "Create Payable Contract",
        SEARCH_PLACEHOLDER: "Search Payable Contract",
        LOADING_DATA: "Loading data...",
    },
    TABLE_COLUMNS: {
        ID: "No",
        TOTAL: "Total",
        NEXT_SERVICE_DEBIT: "Next Debit",
        STATUS: "Status",
        ACTIONS: "Action",
        IS_MONTHLY: "Is Monthly",
        PAY_DATE: "Pay Date",
    },
    MAIN_ACTION_TITLE: "Getting information",
    MAIN_ACTION_DESCRIPTION: "Please wait...",
    VIEW_ACTIVES: "View actives",
    VIEW_INACTIVES: "View inactives",
    DATA: {
        TITLE: "Payable Contract Data",
        TAB_DETAIL: "Contract Detail",
        TAB_ACTIVITY_LOG: "Activity Log",
        TAB_PAYABLE_CONTRACT_DEBITS: "Payable Contract Debits",
        TAB_PAYABLE_CONTRACT_PAYMENTS: "Payable Contract Payments",
    },
}

const DescriptionsEsUs: PayableContractsDescriptions = {
    TITLE: "Contratos de Pago",
    TABLE: {
        ACTION_BUTTON: "Crear Contrato de Pago",
        SEARCH_PLACEHOLDER: "Buscar Contrato",
        LOADING_DATA: "Cargando datos...",
    },
    TABLE_COLUMNS: {
        ID: "No",
        TOTAL: "Total",
        NEXT_SERVICE_DEBIT: "Siguiente Débito",
        STATUS: "Estado",
        ACTIONS: "Acciones",
        IS_MONTHLY: "Es Mensual",
        PAY_DATE: "Día de Pago",
    },
    MAIN_ACTION_TITLE: "Obteniendo información",
    MAIN_ACTION_DESCRIPTION: "Por favor espera...",
    VIEW_ACTIVES: "Ver activos",
    VIEW_INACTIVES: "Ver inactivos",
    DATA: {
        TITLE: "Datos de Contrato de Proveedor",
        TAB_DETAIL: "Detalle de Contrato",
        TAB_ACTIVITY_LOG: "Actividad",
        TAB_PAYABLE_CONTRACT_DEBITS: "Débito de Contrato de Proveedor",
        TAB_PAYABLE_CONTRACT_PAYMENTS: "Pagos de Contrato de Proveedor",
    },
}

export const payableContractsDictionary = {
    [Languages.ENGLISH_US]: DescriptionsEnUs,
    [Languages.SPANISH_US]: DescriptionsEsUs,
}